// extracted by css-extract-rspack-plugin
export default {"centeredFooterItem":"BranchSelector-module__centeredFooterItem__hGHma"};